import Vue from 'vue';
import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    Alert,
    Slider,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Spinner,
    Badge,
    Card,
    Rate,
    Steps,
    Step,
    Carousel,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    ColorPicker,
    Transfer,
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Timeline,
    TimelineItem,
    Link,
    Divider,
    Image,
    Calendar,
    Scrollbar,
    Loading,
    MessageBox,
    Message,
    Notification,
    Popconfirm,
    Drawer
} from 'element-ui';

import { VueAxios, CustomValidator } from '@/plugins';
import i18n from '@/i18n';
import VueProgressBar from 'vue-progressbar';
import { AdminMainHeader } from '@/components/modules/admin';
import { VispTaskService } from '@/components/modules/visp';

import { ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR, ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR_FAIL } from '@/constants.js';

//自定义样式
import '@/assets/scss/element-custom.scss';
import '@/assets/scss/fontawesome.scss';
import './admin.scss';

import App from './App.vue';

import store from '@/store';
import { router } from '@/router.js';

import { AdminGlobalMixin } from '@/mixins.js';

Vue.config.productionTip = false;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Scrollbar);
Vue.use(Popconfirm);
Vue.use(Drawer);

Vue.use(Loading.directive);
Vue.use(VueAxios);
Vue.use(CustomValidator);
Vue.use(VueProgressBar, {
    color: ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR,
    failedColor: ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR_FAIL,
    thickness: '2px',
    autoFinish: false,
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    }
});

Vue.use(AdminMainHeader);
Vue.use(VispTaskService);

Vue.mixin(AdminGlobalMixin);

window.app = new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app');